import { Navigate, Route, Routes } from "react-router-dom";

import { TopNav } from "./components/TopNav";
import { Favorites } from "./screens/Favorites";
import { History } from "./screens/History";
import { Hunt } from "./screens/Hunt";
import { Presets } from "./screens/Presets";

export function App() {
  return (
    <div className="flex min-h-full flex-col">
      <TopNav />
      <Routes>
        <Route path="/" element={<Navigate to="/hunt" replace />} />
        <Route path="/hunt" element={<Hunt />} />
        <Route path="/history" element={<History />} />
        <Route path="/favorites" element={<Favorites />} />
        <Route path="/presets" element={<Presets />} />
        <Route path="*" element={<Navigate to="/hunt" replace />} />
      </Routes>
    </div>
  );
}
